import * as catalogos from './catalogos/de';
export const locale = {
  lang: 'de',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB': 'Speichern von Änderungen..',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG': 'Fragen',
      'TITULO_TAB_TRAD': 'Übersetzung',
      'TITULO_TAB_PREV': 'Vorschau',
      'TAB_PREGUNTAS':{
        'CLA':'Schlüssel:',
        'BTN_CONFIG_PLA': 'Vorlagenkonfiguration',
        'SLI_VER_US_EMPRE': 'Ansicht als geschäftlicher Benutzer',
        'ETI_INSTNES': 'Sie können eine Liste von Fragen laden, die in einer Vorlage enthalten sind, indem Sie folgende Schritte ausführen:',
        'ETI_INST1': 'Laden Sie die Vorlage herunter',
        'ETI_INST2': 'Füllen Sie die Vorlage mit den Fragen entsprechend dem Format aus',
        'ETI_INST3': 'Laden Sie die Vorlage mit den Fragen',
        'ETI_INST_NOT': 'Hinweis: Sie können eine Liste von Fragen allgemein oder innerhalb jedes verfügbaren Abschnitts hochladen',
        'ETI_SECCI_NOT_GRU': 'Dieser Abschnitt hat keine Gruppe',
        'INST_AGRE_GRUP': 'Fügen Sie eine Gruppe von Fragen mit der folgenden Schaltfläche hinzu',
        'BTN_AGRE_GRUP': 'Eine Gruppe hinzufügen',
        'INST2_AGRE_GRUP': 'Sie können dieser Gruppe später Fragen hinzufügen',
        'ETI_DETEC_CAMB_PLAN': 'In der Originalvorlage wurden Änderungen festgestellt',
        'BTN_GUAR_CAMB': 'Änderungen speichern',
        'BTN_GUAR_CAMB_NEW_PLAN': 'Als neue Vorlage speichern',
        'MAT_DESC_PLAN': 'Vorlage herunterladen',
        'ETI_LIS_GRUP': 'Gruppenliste',
        'MAT_CHIP_PRE_EXTR_SI': 'Zusatzfragen vorhanden: ',
        'MAT_CHIP_PRE_EXTR_NO': 'Es können keine zusätzlichen Fragen mehr hinzugefügt werden',
        'MAT_CHIP_PRE_EXTR_ILIM': 'Unbegrenzte Zusatzfragen',
        'ETI_INST_COLO_CUR': 'Platzieren Sie den Cursor über einer beliebigen Gruppe, um die verfügbaren Aktionen zu sehen',
        'MAT_EDIT_NOMB_SECC': 'Bearbeiten Sie den Namen der Gruppe',
        'MAT_DELET_SECC': 'Diese Gruppe entfernen',
        'MAT_AGRE_SECC_ARRI': 'Eine Gruppe oben hinzufügen',
        'ETI_SECC_SIN_PREG': 'Diese Gruppe hat keine Fragen',
        'ETI_SECC_INST_COLO_CUR': 'Bewegen Sie den Cursor über eine Frage, um die verfügbaren Aktionen zu sehen',
        'ETI_PREG_OPCIO_EDITA': 'Optional bearbeitbare Frage',
        'ETI_PREG_OPCIO_NO_EDITA': 'Optionale nicht editierbare Frage',
        'ETI_PREG_OPCIO_OBLI_EDITA': 'Obligatorisch bearbeitbare Frage',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA': 'Obligatorische nicht bearbeitbare Frage',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'Gewünschte frage antwort',
        'MAT_FALT_OPC_RESP': 'Antwortmöglichkeiten fehlen',
        'ETI_FALT_OPC_RESP': 'Frage mit fehlenden Antwortoptionen',
        'MAT_NO_GUAR_CATA': 'Noch nicht im Katalog gespeichert',
        'ETI_PREG_NO_GUAR_CATA': 'Frage noch nicht im Katalog gespeichert',
        'MAT_CHIP_TIP': 'Typ',
        'MAT_TOOL_DETA_PREG': 'Fragendetail',
        'BTN_EDIT_PREG': 'Siehe Einzelheiten',
        'MAT_TOOL_MOVE_PREG': 'Diese Frage verschieben',
        'BTN_EDIT_ES_PREG': 'Diese Frage bearbeiten',
        'BTN_DELE_ES_PREG': 'Diese Frage löschen',
        'MAT_TOOL_AGRE_PREG_ARRI': 'Frage oben hinzufügen',
        'MAT_TOOL_AGRE_PREG_ABAJ': 'Frage unten hinzufügen',
        'MAT_LABE_SELE_VERSI_PREG': 'Eine Version der Frage auswählen',
        'MAT_LABE_TEX_PREG': 'Fragetext',
        'MAT_LABE_TEX_PREG_KEY':'Sonderfrageschlüssel',
        'ETI_CUE_SIG_ACC_PREG': 'Mit den folgenden Aktionen für diese Frage rechnen',
        'MAT_CARD_MAES': 'Stammkatalog',
        'ETI_DETEC_CAMB_TEX_PREG': 'Im Fragentext wurden Änderungen festgestellt',
        'MAT_TOOL_YET_NO_GUA_CAT': 'Noch nicht im Katalog gespeichert',
        'ETI_ESTA_PREG_NO_GUAR_CATA': 'Diese Frage ist nicht im Katalog gespeichert',
        'ETI_GUAR_PREG': 'Diese Frage wird gespeichert',
        'ETI_GUAR_CAMB': 'Änderungen speichern',
        'MAT_SLIDE_PREG_EDIT': 'Editierbare Frage',
        'MAT_SLIDE_PREG_DELET': 'Entfernbare Frage',
        'MAT_SLIDE_PREG_REQUI': 'Obligatorische Antwort',
        'ETI_AGRE_PREG': 'Frage hinzufügen',
        'ETI_GRUP_PREG':'Gruppe von Fragen',
        'ETI_SECC_ESP':'Besonderer Abschnitt',
        'ETI_KEY_NO_EMPL':'Special section key not used',
        'ETI_FALT_KEY_SEC_ESP':'*Special section key missing',
        'ETI_CLA_GRU_LIS':'Schlüsselwort:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG': 'Frage verschieben',
          'ETI_INTS_SELEC_SECC_MOVE': 'Wählen Sie die Gruppe, in die Sie die Frage verschieben möchten',
          'ETI_NOT_PREG_MOVE1': 'HINWEIS:',
          'ETI_NOT_PREG_MOVE2': 'Die Frage wird an das Ende der ausgewählten Gruppe verschoben',
          'BTN_CANCELAR': 'Abbrechen',
          'ETI_CONFI_PLAN': 'Vorlagenkonfiguration',
          'ETI_DATOS_PLAN': 'Vorlagendaten:',
          'ETI_NOMB': 'Name:',
          'ETI_SECC':'Gruppen:',
          'ETI_PREG':'Fragen:',
          'ETI_NOT_CONF_CONT_SECC':'HINWEIS: Die Konfiguration dieser Steuerelemente gilt für alle Gruppen und Fragen in der Vorlage im Anzeigemodus als Geschäftstyp Benutzer',
          'ETI_PERMI_SECC': 'Gruppengenehmigungen',
          'ETI_AGRE_SECC_NEW': 'Neue Gruppen hinzufügen',
          'ETI_MOVE_SECC': 'Gruppen verschieben',
          'ETI_EDIT_TITU': 'Titel bearbeiten',
          'ETI_DELET_SECC': 'Gruppen löschen',
          'ETI_NOMB_OBL_GRUP_NEW':'Obligatorische Namen in neuen Gruppen',
          'ETI_ENABLE_SEC_ESP': 'Aktivieren Sie spezielle Fragen / Abschnitte',
          'ETI_PERMIS_PREG': 'Erlaubnis, Fragen an jede Gruppe zu stellen:',
          'ETI_AGRE_PREG_NEW': 'Neue Fragen hinzufügen',
          'ETI_AGRE_PREG_CATAL': 'Katalogfragen hinzufügen',
          'ETI_MOVE_PREGS': 'Fragen verschieben',
          'ETI_EDIT_PREG': 'Fragen bearbeiten',
          'ETI_DELET_PREG': 'Fragen löschen',
          'ETI_PREG_NEW_MAX': 'Neue maximale Fragen',
          'ETI_MAX_PREG_NEW': 'Maximum an neuen Fragen',
          'ETI_ENABLE_AUDIOS': 'Audiospuren aktivieren',
          'ETI_DEMOGRAF': 'Demografische Daten',
          'ETI_ABIER': 'Offen',
          'ETI_PRAC4ALL': 'Praktiken 4All',
          'ETI_ADICIO': 'Zusätzlich',
          'BTN_SAL': 'Beenden',
          'ETI_INST_AGRE_PREG_CAT': 'Katalogfrage hinzufügen',
          'ETI_BUSC_SELECC_PREG_PLAN': 'In dieser Maske können Sie Fragen suchen und auswählen, um sie der Vorlage hinzuzufügen',
          'ETI_VER_LIS_PREG_SELEC_3_PEST': 'In der dritten Registerkarte dieses Fensters können Sie die Liste der ausgewählten Fragen sehen',
          'TITULO_TAB_LIS_PREG':'Liste der Fragen',
          'TITULO_TAB_BUSC_PREG':'Frage suchen',
          'TITULO_TAB_PREG_SELEC':'Ausgewählte Fragen ',
          'PASO_1':'Schritt 1',
          'PASO_2':'Schritt 2',
          'ETI_SELEC_PREG_LIS_CAT': 'Wählen Sie die Frage aus der Liste im Katalog aus',
          'ETI_SELEC_PREG': 'Wählen Sie eine Frage aus',
          'ETI_YA_SELEC_NUM_MAX_PREG': 'Sie haben bereits die maximal zulässige Anzahl von Zusatzfragen in der Vorlage ausgewählt',
          'ETI_PREG_MS_UNA_VERS': 'Diese Frage hat mehr als eine Version, wählen Sie diejenige aus, die Sie anzeigen möchten',
          'ETI_SELEC_VERS': 'Wählen Sie eine Version',
          'ETI_PREG_SELECCIONDA': 'Ausgewählte Frage:',
          'ETI_AGRE_PREG': 'Frage hinzufügen',
          'ETI_OK_AGRE_PREG_LIST':'<b>Die Frage wurde zur Liste der Fragen hinzugefügt</b>, Sie können weitere Fragen auswählen und zur Vorlage hinzufügen',
          'ETI_OK_AGRE_PREG_LIST2':'Sie können die Liste der ausgewählten Fragen auch in der dritten Registerkarte dieses Fensters sehen',
          'ETI_ESCR_TEXT_BUSC': 'Geben Sie den Text der Frage ein, nach der Sie suchen möchten',
          'ETI_BUSC_PREG_COINC': 'Suche nach passenden Fragen',
          'ETI_NO_ENCO_PREG': 'Es wurden keine Fragen mit dem eingegebenen Text gefunden, versuchen Sie einen anderen Text',
          'ETI_RESUL_BUSC': 'Suchergebnisse',
          'BTN_ELEG': 'Auswählen',
          'ETI_REGRE_RESUL': 'Zu den Ergebnissen zurückkehren',
          'ETI_PREG_SELECC_MOMEN': 'Liste der bisher ausgewählten Fragen',
          'MAT_TOOL_ELEG_VERSI': 'Andere Version wählen',
          'MAT_TOOL_ELI_VERSI':'Version entfernen',
          'BTN_REGRES': 'Rückgabe',
          'BTN_ELIG_VERSI': 'Version auswählen',
          'MAT_TOOL_QUITA_LIS': 'Aus Liste entfernen',

          'BY_TEXT': 'Nach Fragetext',
          'BY_KEYWORDS': 'Nach Stichworten',
          'QUESTION_TEXT': 'Fragetext',
          'QUESTION_KEYWORDS': 'Schlüsselwörter',
          'QUESTION_HINT': 'Schlüsselwörter müssen mit dem Zeichen <b> # </b> beginnen und durch Kommas getrennt werden'
        },
        'DETALLE':{
          'ETI_DETALL_PREG': 'Frage Detail',
          'ETI_LAB_TEX_PREG': 'Fragentext',
          'PLACE_HOL_TEX_PREG': 'Fragentext',
          'MAT_TOOL_EDIT_PREG': 'Diese Frage bearbeiten',
          'MAT_CARD_OPC_RESP': 'Antwortmöglichkeiten',
          'MAT_TOOL_EDIT_RESP': 'Diese Antwort bearbeiten',
          'MAT_TOOL_DELET_RESP': 'Diese Antwort löschen',
          'ETI_AGRE_OPCI_RESP': 'Eine Antwortoption hinzufügen',
          'ETI_SELEC_VERSI_PREG': 'Eine Version der Frage auswählen',
          'ETI_CUENT_SIG_ACC_PREG': 'Mit den folgenden Aktionen für diese Frage rechnen',
          'ETI_DETEC_CAMB_TEXMAES': 'Stammkatalog',
          'ETI_CATA_MAES': 'Master-Katalog',
          'ETI_DETEC_CAMB_TEX_PREG': 'Es wurden Änderungen im Fragentext festgestellt',
          'ETI_DETEC_CAMB_TEX_RESP': 'Es wurden Änderungen in den Antwortoptionen erkannt',
          'ETI_PREG_NO_GUAR_CATA': 'Diese Frage ist nicht im Katalog gespeichert',
          'ETI_GUAR_PREG': 'Diese Frage wird gespeichert',
          'ETI_GUAR_CAMB': 'Änderungen speichern',
          'ETI_BORR_PREGUN':'Frage löschen',
          'ETI_DELET_PREG': 'Frage löschen',
          'MAT_CARD_PLAN': 'Vorlage',
          'MAT_SLIDE_PREG_EDIT': 'Editierbare Frage',
          'MAT_SLIDE_PREG_DELET': 'Entfernbare Frage',
          'MAT_SLIDE_PREG_REQUI': 'Obligatorische Antwort',
          'BTN_REGRES': 'Rückgabe',
          'ETI_NEW_PREG': 'Neue Frage',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE': 'Geben Sie den Text ein und wählen Sie die Art der Antwort für die neue Frage',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP': 'Schreiben Sie den Text und fügen Sie Antwortoptionen für die neue Frage hinzu',
          'ETI_TIP_PREG': 'Fragetyp',
          'ETI_TIP_RESP': 'Antworttyp',
          'ETI_TIP_FORM':'Format der Frage',
          'ETI_PREG_ESP_FLD': 'Sonderfrageschlüssel',
          'ETI_PREG_ESP_HNT': 'Geben Sie den Schlüssel für die spezielle Frage ein',
          'BTN_CANCELAR': 'Abbruch',
          'BTN_CONTINU': 'Fortsetzen',
          'ETI_NEW_PRAC_4ALL': 'Neue 4All-Praxis',
          'ETI_INST_NAME_DESC_4ALL': 'Geben Sie den Namen und die Beschreibung für die neue 4All-Praxis ein',
          'ETI_LABE_NAME': 'Praxisname',
          'ETI_LABE_DESC': 'Beschreibung der Praxis',
          'ETI_CLAVE_DEMOGR': 'Schreiben Sie ein oder mehrere Schlüsselwörter, die die Frage identifizieren, beginnend mit dem Zeichen',
          'ETI_CLAVE_DEMOGR1': 'und durch Kommata getrennt',
          'ETI_CLAVE_DEMOGR2': 'HINWEIS: Schlüsselwörter werden nur gespeichert, wenn Sie diese Frage beim Schließen dieses Fensters im Katalog speichern',
          'ETI_PALA_CLAVE_DEMOGR': 'Schlüsselwörter',
          'ETI_SELE_TIPO_DEMOGR': 'Wählen Sie den Typ der Demografie, der der neuen Frage entspricht',

          'MAT_TOOL_CONFIG_RESP':'Konfigurieren Sie diese Antwort',
          'MAT_SLIDE_RESP_EDIT':'Bearbeitbare Antwort',
          'MAT_SLIDE_RESP_DELET':'Abnehmbare Antwort',
          'MAT_SLIDE_RESP_TIPO_OTRO':'Geben Sie "Andere" ein',
          'MAT_TOOL_NEWVERS_PREG':'Als neue Version speichern',
          'NOTA_PREG_MOD': 'HINWEIS: Der Text dieser Frage wurde geändert. Sie können ihn auf Wunsch als neue Version speichern',
          'RESPUESTA_TIPO_OTRO':' - Antworttyp "Andere"',

          'TIPO_DEMOGRAFICO':'Demografischer Typ',
          'SIN_TIPO_DEMOGRAFICO':'Für diese Frage wurde kein demografischer Typ ausgewählt'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP': 'Neue Vorlage',
          'TEXT_MOD_GUA_CAM_TEMP': 'Geben Sie den Namen für die neue Vorlage ein',
          'BTN_CAN_MOD_GUA_CAM_TEMP': 'Abbrechen',
          'BTN_AGRE_MOD_GUA_CAM_TEMP': 'Hinzufügen',
          'RETUR_MOD_GUA_CAM_TEMP': 'Sie haben keinen Text für den Namen eingegeben',
          'SUCC_TEXT_MOD_GUA_PLAN': 'Die neue Vorlage wurde korrekt gespeichert',
          'TITU_MOD_GUA_CAM_TEMP2': 'Wollen Sie die Änderungen an der ursprünglichen Vorlage speichern? WARNUNG: Bei der nächsten Zuweisung eines Produkts mit dieser Vorlage werden alle bis dahin vorgenommenen Änderungen übernommen',
          'BTN_CONTI_MOD_GUA_CAM_TEMP': 'Weiter',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG': 'Änderungen an der ursprünglichen Vorlage wurden korrekt gespeichert',
          'MENS_1': 'Welche Art von Frage möchten Sie dem Abschnitt hinzufügen?',
          'MENS_2': 'Sie haben zwei Möglichkeiten',
          'BTN_NEW': 'Neu',
          'BTN_D_CATA': 'Aus Katalog',
          'TITU_MOD_CARG_LIS_COLAB_P1': 'Diese Datei enthält',
          'TITU_MOD_CARG_LIS_COLAB_P2': 'Abschnitte und insgesamt',
          'TITU_MOD_CARG_LIS_COLAB_P3': 'Fragen.WARNUNG: Wenn Sie diese Datei weiter laden, werden die aktuellen Fragen und Gruppen ersetzt',
          'TITU_TEX_MOD_CARG_LIS_COLAB': 'Sie haben zwei Möglichkeiten',
          'BTN_AGRE_PREGU': 'Die Fragen hinzufügen',
          'BTN_CANC_PREGU': 'Fragen verwerfen',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB': 'Fragen wurden korrekt hinzugefügt',
          'TEXT_MOD_NOT_CARG_LIS_COLAB': 'Fragen wurden verworfen',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB': 'Die ausgewählte Datei hat Fehler und kann nicht geladen werden. Prüfen Sie noch einmal, ob alle Zeilen in der richtigen Reihenfolge sind und versuchen Sie es erneut',
          'BTN_OK': 'OK',
          'TITU_MOD_NEW_SECC': 'Neuer Abschnitt',
          'TEXT_MOD_NEW_SECC': 'Geben Sie den Namen für den neuen Abschnitt ein',
          'TEXT_SUCC_PREG_AGRE': 'Die Frage wurde korrekt hinzugefügt',
          'TITU_MOD_EDI_SECC': 'Name des Abschnitts ändern',
          'TEXT_SUCC_MODIF_SECC': 'Abschnittsname korrekt geändert',
          'TEXT_SUCC_MODIF_GRU':'Group name was modified',
          'TITU_MOD_DELE_SECC1': 'Sind Sie sicher, dass Sie diesen Abschnitt löschen wollen?',
          'BTN_SI': 'Ja',
          'BTN_NO': 'Nein',
          'TITU_MOD_DELE_SECC2': 'Dieser Abschnitt enthält eine oder mehrere Fragen, was wollen Sie mit diesen Fragen machen',
          'BTN_DELE_PRE': 'Löschen Sie die Fragen',
          'BTN_CAN_TRAN': 'Übertragen Sie sie in den vorherigen Abschnitt',
          'TEX_SUCC_DELE_PREG': 'Der Abschnitt wurde korrekt gelöscht',
          'TITU_AGRE_NEW_PREG': 'Neue Frage',
          'TEXT_AGRE_NEW_PREG': 'Geben Sie den Text für die neue Frage ein',
          'TITU_EDIT_PREG_MOD_PREG': 'Frage modifizieren',
          'TITU_EDIT_PREG_MOD_PRACT': 'Praxis modifizieren',
          'TITU_EDIT_PREG_MOD_DESCRI': 'Beschreibung modifizieren',
          'TEXT_MOD_PREG_SUCC': 'Die Frage wurde korrekt modifiziert',
          'TITU_2_OPCIO': 'Sie haben zwei Möglichkeiten, diese Änderung zu speichern',
          'BTN_CONF_ACT':'Frage aktualisieren',
          'BTN_CANC_NEW':'Als neue Frage',
          'BTN_CONF_ACT_VERSION':'Aktualisieren Sie diese Version',
          'BTN_CANC_NEW_VERSION':'Als neue Version',
          'TEX_CONFIR_MSG1': 'Die Frage wurde korrekt geändert',
          'TEX_CONFIR_MSG2': 'Die Übung wurde korrekt geändert',
          'TEX_CONFIR_MSG3': 'Die Beschreibung wurde korrekt geändert',
          'TITU_DELE_PREG': 'Sind Sie sicher, dass Sie diese Frage löschen wollen?',
          'TEXT_SUCC_PREG': 'Die Frage wurde korrekt gelöscht',
          'TITU_MOD_DELE_SECC_TEMPLA': 'Sind Sie sicher, dass Sie diesen Abschnitt löschen wollen?',
          'TITU_MOD_DELE_SECC_TEMPLA2': 'Dieser Abschnitt enthält eine oder mehrere Fragen, was wollen Sie mit diesen Fragen machen',
          'TEX_SUCC_GUAR_PREG_': 'Die Frage wurde korrekt gespeichert',
          'TITU_MOD_DELE_PREG_MG': 'Sind Sie sicher, dass Sie die Frage aus dem Katalog löschen möchten? WARNUNG: Diese Aktion kann nicht rückgängig gemacht werden und die Frage wird in den Vorlagen, die sie derzeit enthalten, nicht mehr verfügbar sein',
          'TEX_CONFIR_MSG4_DELE': 'Die Frage wurde korrekt aus dem Katalog entfernt',
          'TEX_GUAR_TRADU_SUCC': 'Die Übersetzung wurde korrekt gespeichert',
          'TEX_MOVE_PREG_SECC': 'Die Frage wurde in einen anderen Abschnitt verschoben',
          'TEX_SUCC__PRAC_4ALL': 'Übung wurde korrekt hinzugefügt',
          'MOD_MOD_AGRE_PREG': 'Die Frage wurde korrekt in die Liste aufgenommen',
          'MOD_MOD__MODIF_VERSI_PREG': 'Die Version der Frage wurde korrekt geändert',
          'MOD_MOD__QUIT_PREG_LIST': 'Die Version der Frage wurde korrekt geändert',
          'TITU_NUE_OPC_RESP': 'Neue Antwortmöglichkeit',
          'TEXT_NUE_OPC_RESP': 'Text für neue Option eingeben',
          'TEXT_NO_TEXT_PREG': 'Sie haben keinen Text für die Frage eingegeben',
          'TEXT_AGRE_OPC_RESP': 'Antwortoption korrekt hinzugefügt',
          'MOD_EDIT_RESP': 'Antwortoption modifizieren',
          'MOD_EDIT_MODIF_OPC_RESP': 'Die Antwortoption wurde korrekt modifiziert',
          'MOD_COMFIR_DELE_OPC_RESP': 'Sind Sie sicher, dass Sie diese Antwortoption löschen wollen?',
          'MOD_SUCC_DELE_OPC_RESP': 'Die Antwortoption wurde korrekt gelöscht',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP': 'Die Frage kann nicht fortgesetzt werden, ohne dass Antwortoptionen hinzugefügt werden',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP': 'Sie können nicht fortfahren, ohne vorher den Text der Frage geschrieben zu haben',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP': 'Sie können nicht fortfahren, ohne den Fragetyp ausgewählt zu haben',
          'MOD_AGRE_PREG_DONDE_GUARDAR': 'Möchten Sie die neue Frage vor dem Hinzufügen im Katalog speichern? Oder möchten Sie es einfach in dieser Umfrage haben?',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': 'Wenn Sie es im Katalog speichern, können Sie es auf Wunsch auch anderen Umfragen zur Verfügung stellen.',
          'BOT_DONDE_GUARDAR_1': 'Speichern Sie es im Katalog',
          'BOT_DONDE_GUARDAR_2': 'Speichern Sie es nur in dieser Umfrage',
          'MOD_SIN_TAGS': 'Sie haben noch nicht mindestens ein Schlüsselwort für die Frage eingegeben',
          'MOD_SIN_OPC_RESP': 'Sie haben noch nicht mindestens zwei Antwortoptionen für die Frage eingegeben',
          'MOD_SIN_TIPO_DEMO': 'Sie haben den demografischen Typ für diese Frage noch nicht ausgewählt',
          'MOD_SIN_CLA_ESPE': 'Sie haben den Schlüssel zur speziellen Frage noch nicht hinzugefügt',
          'MOD_SIN_TIPO_RESP': 'Sie können nicht fortfahren, ohne die Art der Antwort auf die Frage auszuwählen',
          'MOD_RESP_DELOK': 'Antwortoption erfolgreich gelöscht',
          'MOD_RESP_DELCATOK': 'Die Frage wurde erfolgreich aus dem Katalog entfernt',
          'MOD_RESP_ADDTAGOK': 'Schlüsselwort zur Frage korrekt hinzugefügt',
          'MOD_RESP_ADDTAGERR': 'Das Schlüsselwort begann nicht mit dem Zeichen #',
          'MOD_RESP_DELTAGOK': 'Das Schlüsselwort wurde korrekt aus der Frage entfernt',
          'MOD_SAVE_CAMBIOS_PREGCAT': 'Beim Speichern von Änderungen an dieser Katalogfrage werden die vorgenommenen Änderungen als neue Versionen der Fragetexte und ggf. der Antwortoptionen gespeichert.\n\nmöchten Sie fortfahren?',
          'MOD_SAVE_CAMB_PREGCAT': 'Wo soll diese Änderung des Fragetextes gespeichert werden?',
          'BTN_MOD_SAVE_CAMB_PREGCAT': 'Nur in dieser Umfrage',
          'BTN_MOD_ACTUA_PREGCAT': 'Die Frage im Katalog aktualisieren',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG': 'Laden',
        'TEXT_NO_ELEG_ADIC': 'Keine zusätzlichen Sprachen gewählt',
        'ERR_MSG_TRADU': 'Übersetzung noch nicht abgeschlossen',
        'TEX_IDIO_PRIN': 'Hauptsprache',
        'TEX_NAM_GRUP': 'Name der Gruppe',
        'TEX_TRAD_NAM': 'Geben Sie die Übersetzung des Namens ein',
        'TEX_NO_TRAD_TEXT': 'Sie haben den Übersetzungstext nicht eingegeben!',
        'TEX_TEX_PREG': 'Fragetext',
        'TEX_TEX_RESP': 'Antworttext',
        'TEX__TRA_PREG': 'Geben Sie die Übersetzung der Frage ein',
        'TEX__TRA_RESP': 'Geben Sie die Übersetzung der Antwort ein',
        'GUAR_TRA_NAM': 'Saving name translation, please wait',
        'GUAR_TRA_PRE': 'Frageübersetzung wird gespeichert, bitte warten',
        'GUAR_TRA_RES': 'Speichern der Übersetzung der Antwortoption, bitte warten',
        'INGR_TEX_PRAC_4ALL': 'Praxis',
        'INGR_TEX_TRADU_PRAC_4ALL': 'Praxisübersetzung eingeben',
        'INGR_TEX_DESCR_4ALL': 'Beschreibung',
        'INGR_TEX_TRADU_DESCR_4ALL': 'Eingabe der Übersetzung der Beschreibung',
        'GUAR_TRADU_PRAC': 'Saving practice translation, please wait...',
        'GUAR_TRADU_DESCR': 'Saving description translation, please wait...',
      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI': 'Wählen Sie eine Sprache, um die Übersetzungen der Fragen anzuzeigen',
        'ETI_SIN_TRAD_PRE':'¡Der Übersetzungstext fehlt!',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': 'Einen Audiotrack hinzufügen',
          'CHANGE': 'Audiospur ersetzen'
        },
        'SUBTITULO': 'Sie können dieser Frage über eine der folgenden Optionen eine Audiospur zuordnen',
        'BOTONES': {
          'RESTART': 'Zurück zum Start',
          'NEXT': 'Nächste',
          'BACK': 'Geh zurück',
          'ACEPTAR': 'Annehmen',
          'CANCELAR': 'Abbrechen'
        },
        'OPCIONES': {
          'GOOGLE': 'Generieren Sie eine automatische Erzählung',
          'RECORD': 'Nehmen Sie eine Erzählung auf',
          'ARCHIVO': 'Laden Sie eine mp3-Datei hoch',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': 'Sie können den Text bearbeiten, um eine automatische Erzählung zu generieren',
            'INPUT': 'Fragetext',
            'INPUT_TT': 'Schreiben Sie den Fragetext',
            'NOTA': 'HINWEIS: Wenn Sie diesen Text ändern, wird der Fragetext in der Umfrage nicht geändert.'
          },
          'RECORD': {
            'TITULO': 'Klicken Sie auf die Schaltfläche Aufnehmen, um die Audioaufnahme vom Mikrofon zu starten',
            'NOTA': 'HINWEIS: Möglicherweise müssen Sie dem Browser die Berechtigung erteilen, das Mikrofon zu verwenden',
            'START': 'Starte die Aufnahme',
            'STOP': 'Audio aufnehmen, klicken Sie auf die Schaltfläche, um die Aufnahme zu stoppen'
          },
          'ARCHIVO': {
            'INPUT': 'Klicken Sie hier oder ziehen Sie die Audiodatei in diesen Bereich, um sie zu laden',
            'NOTA': 'HINWEIS: Nur das MP3-Format wird unterstützt'
          },
          'PREVIEW': {
            'GENERANDO': 'Audio wird generiert, bitte warten Sie einen Moment',
            'TITULO': 'Unten können Sie sich das geladene Audio anhören',
            'NOTA_1': 'Wenn Sie diese Audiospur zur Frage speichern möchten, klicken Sie auf die Schaltfläche OK',
            'NOTA_2': 'Wenn Sie den Ton ändern möchten, klicken Sie auf die Schaltfläche Zurück',
            'NOTA_3': 'Wenn Sie den geladenen Audiotyp ändern möchten, klicken Sie auf die Schaltfläche Zurück zum Start'
          }
        },
        'MODALES': {
          'DESCARTAR': 'Möchten Sie wirklich zum vorherigen Schritt zurückkehren? \n\n Der aktuelle Titel wird verworfen',
          'ARCHIVO_MAL': 'Die hochgeladene Datei ist kein Audiotrack',
          'GUARDANDO': 'Audiotrack zur Frage speichern, warten Sie einen Moment',
          'BORRAR': 'Möchten Sie den mit dieser Frage verknüpften Audiotrack wirklich löschen?',
          'CONFIRMAR_BORRAR': 'Geben Sie zur Bestätigung den roten Code in das Textfeld ein: \n\n',
          'BORRADO_OK': 'Die Audiospur der Frage wurde korrekt gelöscht',
          'CODIGO_MAL': 'Der eingegebene Code stimmt nicht mit dem rot markierten überein',
          'AGREGANDO_PREGUNTAS': 'Ausgewählte Fragen werden dem Abschnitt hinzugefügt, bitte warten Sie einen Moment'
        },
        'PREVIOS': {
          'TITULO': 'Zugehöriger Audiotrack',
          'SIN_AUDIO': 'Es ist kein zugehöriger Audiotrack vorhanden',
          'SIN_AUDIO_FORALL': 'Keine Audiospur',
          'ADD_AUDIO': 'Einen Audiotrack hinzufügen',
          'CON_AUDIO': 'Diese Frage hat eine Audiospur',
          'PLAY': 'Audio abspielen',
          'CHANGE': 'Audio ersetzen',
          'DELETE': 'Audio löschen',
          'AUDIO_STATEMENT_1': 'Audiotrack der Aussage 1',
          'AUDIO_STATEMENT_2': 'Audiotrack der Aussage 2',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': 'Sonderteil',
        'SUBTITULO_1': 'Diese Gruppe von Fragen kann als spezieller Abschnitt eingerichtet werden, die Fragen dieser Gruppe werden nur Mitarbeitern angezeigt, die das gleiche Passwort haben',
        'SUBTITULO_2': 'HINWEIS: Es ist erforderlich, dass diesem speziellen Abschnitt im Schritt zum Hochladen von Mitarbeitern mindestens ein Mitarbeiter zugeordnet ist',
        'TIPOS': {
          'NORMAL': 'Normaler Abschnitt',
          'ESPECIAL': 'Sonderteil'
        },
        'CAMPO': {
          'TITULO': 'Abschnittsschlüssel',
          'TOOLTIP': 'Schreiben Sie den Schlüssel dieses Abschnitts',
          'HINT': 'Kein Platz',
          'ACEPTAR': 'Annehmen'
        },
        'MODALES': {
          'CONFIRM_DISABLE': 'Wenn Sie die speziellen Abschnitte deaktivieren, werden die Fragengruppen, die derzeit als spezielle Abschnitte gekennzeichnet sind, in normale Fragengruppen umgewandelt, diese Änderung gilt für alle Fragenabschnitte. \n\n Möchten Sie wirklich fortfahren?',
          'DISABLE_OK': 'Alle gefundenen Spezialabschnitte wurden in normale Fragengruppen umgewandelt',
          'SIN_CLAVE': 'Um den speziellen Abschnitt zu speichern, müssen Sie einen Schlüssel für den Abschnitt eingeben'
        }
      }
    },
  }
};
